/**
 * @license lucide v0.294.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const FileLineChart = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z" }],
    ["polyline", { points: "14 2 14 8 20 8" }],
    ["path", { d: "m16 13-3.5 3.5-2-2L8 17" }]
  ]
];

export { FileLineChart as default };
//# sourceMappingURL=file-line-chart.js.map
